<template>
  <div>
    <delete-modal
      :yesFunc="deleteItem"
      ref="deleteModalRef"
      :description="$t('description.deleteContent')"
      :title="$t('title.deleteContentTitle')"
    />

     <!-- Add/Update Admin Form START -->
    <v-dialog persistent v-model="adminActionsModal" max-width="1000">
      <v-card>
        <v-card-title class="headline">
          <div class="text-center white--text" style="width: 100%">
            {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="storyFormObserver">
          
          <form @submit.prevent="handleSubmit(submitForm)">
            <v-card-text class="align-center">
              <v-row>
                <v-col cols="auto" class="dense">
                  <ValidationProvider
                    name="Test"
                    v-slot="{ errors }"
                  >
                    <v-checkbox
                      v-model="form.IsTest"
                      label="Test"
                      outlined
                      dense
                      :error-messages="errors[0]"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="dense">
                  <ValidationProvider
                    :name="'Başlık'"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.Title"
                      label="Başlık"
                      outlined
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                  <v-divider class="mb-4"/>
                </v-col>
                <v-col cols="12" md="6" class="dense d-flex flex-column">
                  <v-avatar size="250" class="mb-4 align-self-center" color="var(--primary-color)">
                    <v-img
                      v-if="getImageURL(form.ImageFile) || form.Image"
                      :src="getImageURL(form.ImageFile) || form.Image"
                    />
                    <span v-else class="text--white" style="color: white;">
                      -
                    </span>
                  </v-avatar>
                  <ValidationProvider
                    :name="'Büyük Resim'"
                    :rules="isUpdate ? '' : 'required'"
                    v-slot="{ errors }"
                  >
                    <v-file-input
                    class="w-100"
                      v-model="form.ImageFile"
                      label="Büyük Resim"
                      outlined
                      :error-messages="errors[0]"
                      accept="image/*"
                    ></v-file-input>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="dense d-flex flex-column">
                  <v-avatar size="250" class="mb-4 align-self-center" color="var(--primary-color)">
                    <v-img
                      v-if="getImageURL(form.ThumbnailFile) || form.Thumbnail"
                      :src="getImageURL(form.ThumbnailFile) || form.Thumbnail"
                    />
                    <span v-else class="text--white" style="color: white;">
                      -
                    </span>
                  </v-avatar>
                  <ValidationProvider
                    :name="'Küçük Resim'"
                    :rules="isUpdate ? '' : 'required'"
                    v-slot="{ errors }"
                  >
                    <v-file-input
                      v-model="form.ThumbnailFile"
                      label="Küçük Resim"
                      outlined
                      :error-messages="errors[0]"
                      accept="image/*"
                    ></v-file-input>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <v-divider class="mb-0"/>
                </v-col>
                <v-col cols="12" md="6" class="dense">
                  <ValidationProvider
                    :name="'Sayfa'"
                    v-slot="{ errors }"
                  >
                    <v-select
                      v-model="form.SectionLink"
                      :items="$redirectPages.filter(item => item?.Key !== 'kurumsal_haberler')"
                      label="Sayfa"
                      item-text="Value"
                      item-value="Key"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="dense">
                  <ValidationProvider
                      name="Yönlendirilecek sayfa"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        v-model="form.ContentId"
                        :loading="$store.state.loadingStatus"
                        :items="allInnerModules"
                        :label="$t('labels.selectInnerPage')"
                        item-text="Value"
                        item-value="Key"
                        prepend-icon="mdi-database-search"
                        :error-messages="errors[0]"
                        class="mt-3"
                        cache-items
                        clearable
                        dense
                      ></v-autocomplete>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" class="dense">
                  <v-divider class="mb-4"/>
                  <v-menu
                    ref="datePickerRef"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="expiredDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <ValidationProvider
                        :name="'Yayından Kaldırma Tarihi'"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.ExpireDate"
                          label="Yayından Kaldırma Tarihi"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker v-model="expiredDate" locale="tr-TR">
                      <v-btn text color="primary" @click="expiredDate = null; menu = false; form.ExpireDate = null;">
                      {{ $t(`buttons.${form.ExpireDate ? 'clear' : 'cancel'}`) }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        {{ $t('buttons.cancel') }}
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs?.datePickerRef?.save(expiredDate);
                          form.ExpireDate = convertToLocal(expiredDate);
                        "
                      >
                        {{ $t('buttons.ok') }}
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                small
                class="ma-2 mr-4"
                type="submit"
                elevation="0"
                large
                outlined
                color="red"
              >
                {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
              </v-btn>
              <v-btn
                small
                class="ma-2 mr-4"
                elevation="0"
                large
                outlined
                color="grey"
                @click="adminActionsModal = false"
              >
                {{ $t("buttons.cancel") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Add/Update Admin Form END -->

    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
       <v-row align="center" justify="space-between">
          <v-col cols="auto">
            <div class="text-h6">
              Hikayeler
            </div>
          </v-col>

          <v-col cols="auto">
            <v-btn
              @click="adminActionsModal = true"
              small
              elevation="0"
              outlined
              color="var(--primary-color)"
            >
              <v-icon left small>mdi-plus</v-icon>
              {{ $t("buttons.addNew") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />
      <v-card-text>
        <v-row class="mb-4" align="center">
          <!-- <v-col cols="2">
            <StatusSelect 
              :label="$t('labels.status')"
              clearable
              hide-details
              style="min-width: 180px"
              item-text="label"
              item-value="value"
              prepend-icon="mdi-filter-cog"
              v-model="filters.Status"
              @change="pagination.page = 1; getTableList()"
            />
          </v-col> -->
          <v-col cols="2">
            <v-menu v-model="datePickerVisible" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  :label="$t('labels.startDate')"
                  prepend-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  style="font-size: 11px;"
                />
              </template>
              <v-date-picker v-model="minimumDate" locale="tr-TR">
                <v-spacer />
                <v-btn text color="primary" @click="clearDateFilter">
                  {{ $t(`buttons.${minimumDate?.length > 0 ? 'clear' : 'cancel'}`) }}
                </v-btn>
                <v-btn text color="primary" @click="applyDateFilter">
                  {{ $t("buttons.ok") }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="auto" class="ml-auto">
            <v-text-field
              v-model="filters.Title"
              append-icon="mdi-magnify"
              @click:append="getTableList"
              :label="$t('labels.search')"
              v-on:keyup.enter="getTableList"
              @click:clear="filters.Title = ''; getTableList()"
              clear-icon="mdi-close-circle"
              clearable
              single-line
              hide-details
              style="min-width: 250px"
            />
          </v-col>
        </v-row>

        <v-row class="mb-4" v-if="selectedPostsCount > 0">
          <v-col cols="12">
            <v-divider  class="mb-4" />
            {{ selectedPostsCount }} adet gönderi seçildi.
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="quickUpdateStatus"
              :items="[
                { label: 'Sil', value: 'delete' },
                { label: 'Düzenle', value: 'update' }
              ]"
              :label="$t('labels.action')"
              clearable
              hide-details
              style="min-width: 180px"
              item-text="label"
              item-value="value"
            />
          </v-col>
          <!-- UPDATE seçilince ikinci select -->
          <v-col cols="3" v-if="quickUpdateStatus === 'update'">
            <StatusSelect
              v-model="updateStatusValue"
              :items="statusItems"
              label="Durum"
              clearable
              hide-details
              :inactiveValues="[null, 30]"
              style="min-width: 180px"
              item-text="label"
              item-value="value"
            />
          </v-col>
          <v-col cols="3" v-if="canApplyBulkUpdate">
            <v-btn
              small
              class="ma-4 mr-8"
              elevation="0"
              outlined
              color="info"
              @click="bulkUpdate()"
            >
              {{ $t('buttons.apply') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-model="selectedItems"
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="pagination"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
          @click:row="updateStory"
        >
          <template v-slot:item.Content="{ item }">
            <div
              style="
                max-height: 40px;
                max-width: 300px;
                overflow-y: scroll;
                overflow-y: hidden;
              "
              v-html="
                item.Content.length > 0 ? item.Content : 'İçeriksiz Gönderi'
              "
            ></div>
          </template>
          <template v-slot:item.Image="{ item }">
            <v-avatar v-if="item.Image" size="36">
              <v-img :src="item.Image" alt="" />
            </v-avatar>
          </template>
          <template v-slot:item.Thumbnail="{ item }">
            <v-avatar v-if="item.Thumbnail" size="36">
              <v-img :src="item.Thumbnail" alt="" />
            </v-avatar>
          </template>
          <template v-slot:item.Creator="{ item }">
            {{ item?.User 
                ? `${item.User.Name} ${item.User.Surname}` 
                : 'Atanmamış' }}
          </template>
          <template v-slot:item.Status="{ item }">
            <v-chip v-if="isScheduled(item.SendedAt) && item.Status === 10" :color="statusMap['Scheduled'].color">
              <span :style="{ color: statusMap['Scheduled'].textColor }">
                <v-icon class="mr-1" dark>
                  mdi-clock
                </v-icon> {{ statusMap['Scheduled'].text }}
              </span>
            </v-chip>
            <div v-else style="font-weight: bold !important;">
              <v-chip :color="statusMap[item.Status].color">
                <span :style="{ color: statusMap[item.Status].textColor }">
                  {{ statusMap[item.Status].text }}
                </span>
              </v-chip>
            </div>
          </template>
          <template v-slot:item.ExpireDate="{ item }">
            {{ convertToLocal(item.ExpireDate) }}
          </template>
          <template v-slot:item.CreatedAt="{ item }">
            {{ convertToLocal(item.CreatedAt) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click.stop="updateStory(item)"
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  class="mr-2"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status !== 30">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  small
                  @click.stop="openDeleteModal(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipDelete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-row class="my-2">
          <v-spacer />

          <v-col cols="3">
            <v-select
              v-model="pagination.itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="getTableList"
            />
          </v-col>
        </v-row>
        <div class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ContentService from "../services/ContentService";
import ModuleService from "../services/ModuleService";
import PostService from "../services/PostService";
import CategoryService from "../services/CategoryService";
import DeleteModal from "../components/General/DeleteModal";
import StatusSelect from "../components/StatusSelect.vue";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import StoryService from "../services/StoryService.js";
import { ValidationProvider } from "vee-validate";
import FileService from "../services/FileService.js";

dayjs.extend(customParseFormat)
dayjs.extend(utc);

export default {
  data: () => ({
    quickUpdateStatus: null,
    updateStatusValue: null,
    selectedItems: [],
    statusMap: {
      0: { text: "Taslak", color: "#f5f5f5", textColor: "#666" },
      10: { text: "Yayında", color: "green", textColor: "white" },
      20: { text: "Pasif", color: "#bdbdbd", textColor: "#444" },
      30: { text: "Silindi", color: "#FF7066", textColor: "white" },
      Scheduled: { text: "Zamanlandı", color: "#03aecc", textColor: "white" }
    },
    //List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    key: "",
    //Table contents
    headers: [],

    //Page loaders
    loadings: {
      table: false,
      send: false,
    },

    //Page detail
    moduleDetail: {},

    //delete model item
    deleteItemModel: {},

    search: "",
    //Pagination models
    pagination: {
      itemsPerPage: 15,
      page: 1,
    },
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],
    pageHeader: "",
    pageId: -1,
    moduleDescription: "",
    //Page restrictions
    pageRules: null,
    selectedCategoriesModal: [],
    categoryData: [],
    searchCategory: "",

    filters: {
      Status: null,
      Title: ""
    },

    minimumDate: "",
    datePickerVisible: false,

    adminActionsModal: false,
    isUpdate: false,
    form: {},
    expiredDate:  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    allInnerModules: []
  }),
  watch: {
    adminActionsModal(newValue){
      if(!newValue){
        this.form = {};
        this.isUpdate = false;
        this.$refs?.storyFormObserver?.reset();
      }
    }
  },
  beforeMount() {
    this.pageRules = getPageRulesById(this.$route.params.id);
    console.log(this.pageRules)
    this.moduleDetail = {
      Name: this.pageRules.adi,
      Key: this.pageRules.key
    }
  },
  mounted() {
    this.setup();
    this.getTableList();
  },
  components: {
    StatusSelect,
    DeleteModal,
  },
  computed: {
    canApplyBulkUpdate(){
      let canApply = false;

      if(this.quickUpdateStatus === "delete") canApply = true;
      else if(this.quickUpdateStatus === "update" && this.updateStatusValue !== undefined && this.updateStatusValue !== null) canApply = true;
      
      return canApply;
    },
    selectedPostsCount(){
      return this.selectedItems.length || 0;
    },
    dateRangeText() {
      return this.minimumDate ? dayjs(this.minimumDate).format('DD.MM.YYYY') : ""
    },
        
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.itemsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.itemsPerPage
      );
    },

    filter() {
      return this.true
        ? (item, searchCategory, textKey) =>
            item[textKey].indexOf(searchCategory) > -1
        : undefined;
    },
  },
  methods: {
    getImageURL(file){
      if (!file) {
        return null;
      }

      return URL.createObjectURL(file);
    },
     /**
     * Get Posts
     * @param {{ Value: string, Key: string, IsDetail: boolean, IsRedirectPage: boolean }} modal
     */
    fillInnerSelectPage(modal) {
      this.allInnerModules = [];
      this.$store.state.loadingStatus = true;
      ContentService.getPosts({ key: null, Page: 1, PageSize: 50 })
      .then((res) => {
        res.data.Data.forEach((x) => {
          this.allInnerModules.push({
            Key: x.Id,
            Value: x.Title
              ? x.Title
              : x.Content
              ? x.Content.split(" ").slice(0, 5)
              : x.User.FullName + " Gönderisi",
          });
        });
      })
      .catch(window.showError)
      .finally(() => this.$store.state.loadingStatus = false);
    },

    async submitForm() {
      this.$store.state.loadingStatus = true;

      try {
        let imageURL = "", thumbnailURL = "", expiredDate = null, formData = new FormData(), newFile = false;

        formData.append("Type", 1)
        if(this.form.ImageFile){
          formData.append("Files", this.form.ImageFile)
          newFile = true;
        }
        if(this.form.ThumbnailFile){
          formData.append("Files", this.form.ThumbnailFile)
          newFile = true;
        }
        
        if(newFile){
          const { data } = await FileService.uploadFile(formData);
          
          if(Array.isArray(data) && data.length > 0){
            imageURL = data[0]?.LocalUrl;
            thumbnailURL = data[1]?.LocalUrl;
          }
        }
        else{
          imageURL = this.form.Image;
          thumbnailURL = this.form.Thumbnail;
        }
        
        if(this.form.ExpireDate){
          const date = dayjs(this.form.ExpireDate, "DD.MM.YYYY");
          expiredDate = date.toISOString();
        }
       
        const payload = {
          Title: this.form.Title,
          "Image": imageURL,
          "Thumbnail": thumbnailURL,
          "ExpireDate": expiredDate,
          "SectionLink": this.form.Link?.Key,
          "ContentId": this.form.ContentId,
          "IsTest": this.form.IsTest
        };

        if(this.isUpdate) payload.Id = this.form.Id; 

        await StoryService[`${this.isUpdate ? 'update' : 'create'}Story`](payload);
        this.getTableList();
        this.adminActionsModal = false;
        window.showSuccess(
          this.$t(
            `messages.${
              this.isUpdate ? "updatedSuccessfully" : "addedAdminSuccessfully"
            }`,
          ),
        );
      } catch (e) {
        window.showError(e);
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },

    isScheduled(date) {
      const scheduledDate = dayjs.utc(date, 'D.MM.YYYY HH:mm:ss')
      return scheduledDate.isAfter(dayjs())
    },

    bulkUpdate(){
      let status = null;

      if(this.quickUpdateStatus === "delete"){
        status = 30;
      }
      else if(this.quickUpdateStatus === "update"){
        status = this.updateStatusValue;
      }

      if(status === null || status === undefined) return;

      const items = this.selectedItems.flatMap(item => item.Id);

      if(Array.isArray(items) && items.length > 0){
        this.$store.state.loadingStatus = true;
        PostService.bulkUpdate(items, status)
        .then(() => {
          window.showSuccess("Verileriniz başarılı bir şekilde güncellendi.")
          this.getTableList()
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        })
      }
      
    },
    copy(postId){
      this.$store.state.loadingStatus = true;
      PostService.copyPost(Number(postId))
      .then(response => {
        const data = response?.data;
        if(data?.Id){
          this.$router.push({
            path: `/home/updateContent/${data.Id}`,
            query: {
              pageName: this.pageHeader || "",
              moduleDescription: data.Description || "",
              pageId: data.Key || -1,
            },
          });
        }
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      })
    },

    clearDateFilter() {
      this.minimumDate = null;
      this.datePickerVisible = false;
      this.getTableList();
    },
    applyDateFilter() {
      this.datePickerVisible = false;
      this.getTableList()
    },
    
    tableTitle(item) {
      return item.Content <= 0 ? "İçeriksiz Gönderi" : item.Content;
    },

    async setup() {
      this.headers = [
        { text: "Başlık", value: "Title", sortable: false },
        { text: "Resim", value: "Image", sortable: false },
        { text: "Küçük Resim", value: "Thumbnail", sortable: false },
        // { text: "İçerik", value: "Content", sortable: false },
        { text: "Yayından Kaldırılma Tarihi", value: "ExpireDate", sortable: false },
        { text: "Oluşturulma Tarihi", value: "CreatedAt", sortable: false },
        { text: "Durumu", value: "Status", sortable: false },
        { text: "İşlem", value: "actions", sortable: false },
      ];
      await this.getCategories();

      this.pagination = {
        totalItems: 200,
        rowsPerPage: this.itemsPerPage,
        page: 1,
      };

      this.fillInnerSelectPage();
    },
    async getCategories() {
      return new Promise(async (resolve, reject) => {
        try {
          if (this.pageRules.categoryIds.length > 0) {
            await Promise.all(
              this.pageRules.categoryIds.map(async (element, index) => {
                await CategoryService.getCategoriesInTreeView(element.id)
                  .then((res) => {
                    this.categoryData = this.categoryData.concat(res.data);
                  })
                  .catch((err) => {
                    window.handleServiceError(res, err);
                  })
                  .then(() => {});
              })
            );
          }
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
    
    //Loads page list
    getTableList() {
        this.$store.state.loadingStatus = true;

      let params = {
          Key: "stories",
          PageSize: this.pagination.itemsPerPage,
          Page: this.pagination.page,
        };

      if(this.minimumDate){
        params['StartDate'] = this.minimumDate;
      }

      params = { ...params, ...this.filters };

      this.tableData = [];
      StoryService.getStories(params)
        .then((res) => {
          const data = res.data;
          const list = data?.Data || [];

          if(list?.length > 0){
            this.tableData = res.data.Data;
            this.pagination.totalItems = res.data.TotalData;
          }
        })
        .catch(window.showError)
        .finally(this.$store.state.loadingStatus = false);
    },

    getCompanyNames(item) {
      let tempString = "";
      item.Groups.forEach((element) => {
        tempString += element.Name + "<br/>";
      });
      return tempString;
    },

    updateStory(item) {
      this.isUpdate = true;
      this.form = Object.assign({}, item);
      this.form.ExpireDate = dayjs(item.ExpireDate).format('DD.MM.YYYY')
      this.adminActionsModal = true;
    },

    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },
    
    deleteItem() {
      this.$store.state.loadingStatus = true;
      StoryService.deleteStory(this.deleteItemModel.Id)
        .then(() => {
          window.showSuccess("Başarılı bir şekilde silindi.");
          this.getTableList();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        })
    },

    publishOperation(item, status) {
      let body = {
        Id: item.Id,
        Status: status
      };

      this.$store.state.loadingStatus = true;
      ContentService.changeContentStatus(body)
        .then(() => {
          item.Status = body.Status;
          window.showSuccess('Durum başarılı bir şekilde güncellendi.')
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.$refs.deleteModalRef.modalStatus = false;
        });
    },

    selectOneCategory(selectedCategory) {
      if (selectedCategory.length > 0) {
        console.log("Selected cat value > ", selectedCategory[0]);
        this.getTableList(selectedCategory[0].Id, true);
      } else {
        console.log("Boş table list");
        this.getTableList();
      }
    },
  },
};
</script>
<style>
.clickable-row {
  cursor: pointer !important;
}
.dense{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>